class QuizResultProducts extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    const sectionId = 'section-quiz-result-products';
    const path = window.location.pathname;
    fetch(`${path}/?section_id=${sectionId}`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const section = doc.querySelector(`#${sectionId}`);
        const destination = this.querySelector(`#${sectionId}`);
        destination.innerHTML = section.innerHTML;
      })
  }

  /* connectedCallback() {
    this.init();
  } */
}

customElements.define('quiz-result-products', QuizResultProducts);